/**
 * React Query `placeholderData` that keeps the previous response on screen only when the last key
 * segment (the filter string) changed. Moving to another date or month still shows the loader,
 * so a stale day is never displayed under the wrong title.
 */
export function keepWhenOnlyFiltersChange<T>(currentKey: readonly unknown[]) {
  return (previous: T | undefined, previousQuery?: { queryKey: readonly unknown[] }): T | undefined => {
    if (!previousQuery) return undefined;
    const before = previousQuery.queryKey.slice(0, -1);
    const now = currentKey.slice(0, -1);
    const sameView = before.length === now.length && before.every((part, i) => part === now[i]);
    return sameView ? previous : undefined;
  };
}
